import {
    EmailFieldRHF,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
} from "@websential/cosmic-v20";
import { Grid, useTheme } from "@mui/material";

import { FC } from "react";
import { Link } from "react-router-dom";

interface IWorkableSetupFieldsPanel {
}
export const WorkableSetupFieldsPanel: FC<
    IWorkableSetupFieldsPanel
> = ({ }) => {
    const theme = useTheme();
    return (
        <>
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Grid size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }} sx={{ background: "#ffffff", padding: "2rem", alignItems: "center", textAlign: "center", fontSize: ".875rem", border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "2px" }}>
                    <Link
                        to={`#`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Click here
                    </Link>
                    &nbsp;&nbsp;
                    <span style={{ color: "#FF6600", fontSize: ".875rem" }}>
                        to allow SimplePay to access your account.
                    </span>
                </Grid>
            </Grid>
        </>
    );
};
